module.exports = __webpack_public_path__ + "icons/original/large/large-e1.b1cd43842afa4b29b592e9ac499769ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-e1.png
// module id = ZvN9
// module chunks = app